import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTenantStore } from '@/store/tenantStore';
import { usePageTitleStore } from '@/store/pageTitleStore';
import { formatDocumentTitle, routePageTitle } from './pageTitles';

/** Sets document.title for the current route (see pageTitles.ts). */
export function DocumentTitle({ isMaintenanceMode = false }: { isMaintenanceMode?: boolean }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  // Flutter AppConfig.appTitle: contentSettings.general.name ?? 'Career Portal'
  const brand = useTenantStore((s) => s.content?.contentSettings?.general?.name) ?? 'Career Portal';
  const pageTitle = usePageTitleStore((s) => s.title);

  const routeTitle = routePageTitle(pathname);
  // Maintenance mode replaces every page, so only the tenant name is shown
  const page = isMaintenanceMode ? undefined : pageTitle || (routeTitle ? t(routeTitle) : undefined);
  const title = formatDocumentTitle(page, brand.trim());

  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
